import { NodeDataProps } from "components/ObjectTemplateCanvas/utils";
import { Direction } from "containers/Resources/screens/ResourcesSingle/components/Visualization/visualization.service";
import { memo } from "react";
import { Handle, Position } from "reactflow";
import "reactflow/dist/style.css";
import { ObjectTemplateCard } from "./ObjectTemplateCard";

export interface CanvasNodeProps<T> {
    id: string;
    data: T;
    isConnectable: boolean;
}

export const ObjectTemplateNode = memo(
    ({ id, data, isConnectable }: CanvasNodeProps<NodeDataProps>) => {
        const isHorizontalDirection = data.layoutDirection === Direction.Horizontal;

        return (
            <div className="nowheel">
                <ObjectTemplateCard
                    data={data.value}
                    fetchObjectTemplateList={data.fetchObjectTemplateList}
                    deleteNewForm={data.deleteNewForm}
                    setNestedFormsData={data.setNestedFormsData}
                    nestedFormsData={data.nestedFormsData}
                    formStructure={data.formStructure}
                    setLoading={data.setLoading}
                    isFocused={data.isFocused}
                />
                <Handle
                    type="source"
                    id="source"
                    position={isHorizontalDirection ? Position.Right : Position.Bottom}
                    isConnectable={isConnectable}
                />
                <Handle
                    type="target"
                    id="target"
                    position={isHorizontalDirection ? Position.Left : Position.Top}
                    isConnectable={isConnectable}
                />
            </div>
        );
    }
);
